
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CompanyMission() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className="bg-gray-50 py-32 lg:py-40 px-8 lg:px-32">
      <div className="max-w-6xl mx-auto">
        <div
          className={`mb-20 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-4xl lg:text-5xl font-medium text-gray-900 mb-3">Mission</h2>
          <p className="text-base text-gray-500">私たちの使命</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div
            className={`transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            <h3 className="text-3xl font-light text-gray-900 leading-relaxed mb-8">
              Making Things,<br />Across Every Space.
            </h3>
            <p className="text-base text-gray-700 leading-loose mb-6">
              私たちは「Making Things」を軸に、空間ごとにふさわしいモノ・体験・仕組みを生み出すクリエイティブプロデュースチームです。プライベート空間からパブリック空間、グローバル基準の環境まで、あらゆる場所で価値を創造します。
            </p>
            <p className="text-sm text-gray-500 leading-loose">
              We are a creative production team focused on &ldquo;Making Things&rdquo; across private, public, and global environments. From product development to interactive installations and global‑standard delivery, we bridge the gap between vision and reality.
            </p>
          </div>

          <div
            className={`space-y-8 transition-all duration-700 delay-300 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}
          >
            {[
              {
                titleJa: 'プロダクト × ブランド',
                titleEn: 'Products & Brands',
                descJa:
                  'MeVERブランドを通じて、個人の仕事・創作・生活に寄り添うワーク＆ライフスタイルプロダクトを企画・開発。',
              },
              {
                titleJa: 'インタラクティブ × 体験',
                titleEn: 'Interactive Experiences',
                descJa:
                  'カナダのクリエイティブスタジオmirariとの協業により、没入型インスタレーションの日本展開を推進。',
              },
              {
                titleJa: 'グローバル × 実装',
                titleEn: 'Global Delivery',
                descJa:
                  '在日米軍基地を含むグローバル基準空間における調達・施工・実装支援を提供。',
              },
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-sm">
                <p className="text-lg font-medium text-gray-900 mb-1">{item.titleJa}</p>
                <p className="text-xs text-gray-400 mb-4">{item.titleEn}</p>
                <p className="text-sm text-gray-600 leading-relaxed">{item.descJa}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
